import React, { useEffect, useState, useCallback } from "react";
import * as XLSX from "xlsx";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  dateFormatter,
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import {
  getUsersPaginated,
  deleteUser,
  changeStatusUser,
  updateUser,
} from "../../../../api/user";
import {
  Button,
  Tooltip,
  Switch,
  FormControlLabel,
  TextField,
  Checkbox,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
  Select as MuiSelect,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import GetAppIcon from "@material-ui/icons/GetApp";
import AddIcon from "@material-ui/icons/Add";
import { Autorenew as FilterOffIcon } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import {
  canEditUsersModule,
  isReadOnlyConsultor,
} from "../../../../_helpers/backofficePermissions";
import FiltersCard from "../../../components/filters/Filter";
import { getUserTypes } from "../../../../api/userType";
import { getProvincias } from "../../../../api/provincia";
import Select from "react-select";

function getData(users, types) {
  let data = [];
  if (!users || !Array.isArray(users)) return data;
  for (let i = 0; i < users.length; ++i) {
    if (users[i] && users[i].role === "user" && users[i].asociado) {
      const elem = {};
      elem.name = users[i].fullName;
      elem.apellido1 = users[i].apellido1;
      elem.apellido2 = users[i].apellido2;
      elem.dni = users[i].dni;
      elem.afiliado = users[i].afiliacion || users[i].afiliado;
      elem.ultimoPago = users[i].ultimoPago;
      elem.email = users[i].email;
      elem.iban = users[i].iban;
      elem.type = types?.find((x) => x._id == users[i].type)?.titulo;
      elem.typeId = users[i].type ? String(users[i].type) : null; // Guardar ID para filtros (normalizado a string)
      elem.nAso = users[i].nAso;
      elem.createdAt = users[i].createdAt;
      elem.fechaAlta = users[i].fechaAlta; // Para filtro de fecha
      elem.provincia = users[i].provincia; // Para filtro de provincia
      elem.id = users[i]._id;
      elem.active = users[i].active;
      elem.seram = users[i].seram || false;
      data = data.concat(elem);
    }
  }
  return data;
}

const initialFilters = {
  active: false,
  tipoUsuario: [],
  nAso: "",
  provincia: null,
  fechaAltaDesde: "",
  fechaAltaHasta: "",
};

const PAGE_SIZE_OPTIONS = [25, 50, 100];

/** Máximo que acepta el backend en GET /user (user.controller findAll) */
const EXPORT_PAGE_LIMIT = 100;

// Mapeo dataField (tabla) -> campo en backend para ordenación
const SORT_FIELD_TO_BACKEND = {
  name: "fullName",
  apellido1: "apellido1",
  apellido2: "apellido2",
  dni: "dni",
  email: "email",
  iban: "iban",
  type: "type",
  nAso: "nAso",
  afiliado: "afiliacion",
  ultimoPago: "ultimoPago",
  createdAt: "createdAt",
  seram: "seram",
};

function escapeCsvField(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

/** Misma lógica visual que dateFormatter en table.js (sin "---" en CSV). */
function formatSociosDateForCsv(cell) {
  if (!cell) return "";
  const date = new Date(cell);
  if (isNaN(date.getTime())) return "";
  return `${date.getDate()}/${date.getMonth() +
    1}/${date.getFullYear()}  ${date.getHours()}:${String(
    date.getMinutes(),
  ).padStart(2, "0")}`;
}

const SOCIOS_CSV_HEADERS = [
  "Nombre",
  "Apellido 1",
  "Apellido 2",
  "DNI",
  "Email",
  "IBAN",
  "Tipo Usuario",
  "Nº Socio",
  "Afiliación",
  "Último pago",
  "Fecha Alta",
  "SERAM",
];

function sociosRowsToCsv(rows) {
  const lines = [SOCIOS_CSV_HEADERS.map(escapeCsvField).join(",")];
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    lines.push(
      [
        escapeCsvField(row.name),
        escapeCsvField(row.apellido1),
        escapeCsvField(row.apellido2),
        escapeCsvField(row.dni),
        escapeCsvField(row.email),
        escapeCsvField(row.iban),
        escapeCsvField(row.type),
        escapeCsvField(row.nAso),
        escapeCsvField(formatSociosDateForCsv(row.afiliado)),
        escapeCsvField(formatSociosDateForCsv(row.ultimoPago)),
        escapeCsvField(formatSociosDateForCsv(row.createdAt)),
        escapeCsvField(row.seram ? "Sí" : "No"),
      ].join(","),
    );
  }
  return lines.join("\r\n");
}

function sociosRowsToXlsxAoA(rows) {
  const aoa = [SOCIOS_CSV_HEADERS];
  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    aoa.push([
      row.name ?? "",
      row.apellido1 ?? "",
      row.apellido2 ?? "",
      row.dni ?? "",
      row.email ?? "",
      row.iban ?? "",
      row.type ?? "",
      row.nAso ?? "",
      formatSociosDateForCsv(row.afiliado),
      formatSociosDateForCsv(row.ultimoPago),
      formatSociosDateForCsv(row.createdAt),
      row.seram ? "Sí" : "No",
    ]);
  }
  return aoa;
}

export default function SociosPage() {
  const [data, setData] = useState([]);
  const [userId, setUserId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [userTypes, setUserTypes] = useState([]);
  const [users, setUsers] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(() => {
    const saved = localStorage.getItem("sociosPage_currentPage");
    return saved ? parseInt(saved, 10) : 1;
  });
  const [totalPages, setTotalPages] = useState(1);
  const [totalSocios, setTotalSocios] = useState(0);
  const [provincias, setProvincias] = useState([]);
  const normalizeTipoUsuario = (raw) =>
    Array.isArray(raw?.tipoUsuario)
      ? raw.tipoUsuario
      : raw?.tipoUsuario
      ? [raw.tipoUsuario]
      : [];
  const [filterOptions, setFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem("sociosPageFilters");
    const raw = savedFilters ? JSON.parse(savedFilters) : initialFilters;
    return {
      ...initialFilters,
      ...raw,
      tipoUsuario: normalizeTipoUsuario(raw),
    };
  });
  const [appliedFilterOptions, setAppliedFilterOptions] = useState(() => {
    const savedFilters = localStorage.getItem("sociosPageFilters");
    const raw = savedFilters ? JSON.parse(savedFilters) : initialFilters;
    return {
      ...initialFilters,
      ...raw,
      tipoUsuario: normalizeTipoUsuario(raw),
    };
  });
  const [searchText, setSearchText] = useState(() => {
    const saved = localStorage.getItem("sociosPage_searchText");
    return saved || "";
  });
  const [appliedSearchText, setAppliedSearchText] = useState(() => {
    const saved = localStorage.getItem("sociosPage_searchText");
    return saved || "";
  });
  const [sortBy, setSortBy] = useState(() => {
    const saved = localStorage.getItem("sociosPage_sortBy");
    return saved || "createdAt";
  });
  const [sortOrder, setSortOrder] = useState(() => {
    const saved = localStorage.getItem("sociosPage_sortOrder");
    return saved === "asc" ? "asc" : "desc";
  });
  const [pageSize, setPageSize] = useState(() => {
    const saved = localStorage.getItem("sociosPage_pageSize");
    const n = saved ? parseInt(saved, 10) : 100;
    return PAGE_SIZE_OPTIONS.includes(n) ? n : 100;
  });
  const [exportingCsv, setExportingCsv] = useState(false);
  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  const buildSociosQueryParams = useCallback(
    (page, limit) => {
      const params = {
        page,
        limit,
        role: "user",
        asociado: true,
      };
      if (appliedFilterOptions.active) params.active = true;
      if (appliedFilterOptions.tipoUsuario?.length)
        params.tipoUsuario = appliedFilterOptions.tipoUsuario;
      if (appliedFilterOptions.provincia)
        params.provincia = appliedFilterOptions.provincia;
      if (appliedFilterOptions.fechaAltaDesde)
        params.fechaAltaDesde = appliedFilterOptions.fechaAltaDesde;
      if (appliedFilterOptions.fechaAltaHasta)
        params.fechaAltaHasta = appliedFilterOptions.fechaAltaHasta;
      if (appliedFilterOptions.nAso) params.nAso = appliedFilterOptions.nAso;
      if (appliedSearchText) params.search = appliedSearchText;
      const backendSortBy = SORT_FIELD_TO_BACKEND[sortBy] || "createdAt";
      params.sortBy = backendSortBy;
      params.sortOrder = sortOrder;
      return params;
    },
    [appliedFilterOptions, appliedSearchText, sortBy, sortOrder],
  );

  // Handler para actualizar la búsqueda (se usa tanto desde el TextField como desde el Table)
  const handleTableSearchChange = useCallback((value) => {
    const trimmedValue = value ? value : "";
    setSearchText(trimmedValue);
    if (trimmedValue) {
      localStorage.setItem("sociosPage_searchText", trimmedValue);
    } else {
      localStorage.removeItem("sociosPage_searchText");
    }
  }, []);

  const handleSeramChange = async (userId, currentSeram) => {
    try {
      // Actualizar solo el campo seram
      const updatedUser = { seram: !currentSeram };
      const response = await updateUser(userId, updatedUser);

      if (response.status === 200) {
        alertSuccess({
          title: "Actualizado!",
          customMessage: `SERAM ${
            !currentSeram ? "activado" : "desactivado"
          } correctamente.`,
        });
        setRefresh(true);
      }
    } catch (error) {
      alertError({
        error: error,
        customMessage: "No se pudo actualizar SERAM.",
      });
    }
  };

  function seramFormatter(cell, row) {
    return (
      <Checkbox
        checked={row.seram || false}
        onChange={() => handleSeramChange(row.id, row.seram)}
        color="primary"
        disabled={
          !(canEditUsersModule(user?.role) && !isReadOnlyConsultor(user?.role))
        }
      />
    );
  }

  function buttonFormatter(cell) {
    const transformedData = getData(data, userTypes);
    const elem = transformedData.find((item) => item.id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              localStorage.setItem("editUserFromSocios", "true");
              history.push("/edit-user/" + cell, { fromSocios: true });
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {(canEditUsersModule(user?.role) && !isReadOnlyConsultor(user?.role)) && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(cell);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "name", text: "Nombre", sort: true },
    { dataField: "apellido1", text: "Apellido 1", sort: true },
    { dataField: "apellido2", text: "Apellido 2", sort: true },
    { dataField: "dni", text: "DNI", sort: true },
    { dataField: "email", text: "Email", sort: true },
    { dataField: "type", text: "Tipo Usuario", sort: true },
    { dataField: "nAso", text: "Nº Socio", sort: true },
    {
      dataField: "afiliado",
      text: "Afiliación",
      sort: true,
      formatter: dateFormatter,
    },
    {
      dataField: "ultimoPago",
      text: "Último pago",
      sort: true,
      formatter: dateFormatter,
    },
    {
      dataField: "createdAt",
      text: "Fecha Alta",
      sort: true,
      formatter: dateFormatter,
    },
    {
      dataField: "seram",
      text: "SERAM",
      sort: true,
      formatter: seramFormatter,
      headerAlign: "center",
      align: "center",
    },
    { dataField: "id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getUserTypes().then((res) => {
      const asociados = res.data.filter((t) => t.asociado === true);
      setUserTypes(asociados);
    });
    getProvincias().then((res) => {
      if (res.status === 200) {
        setProvincias(res.data);
      }
    });
  }, []);

  const handleExportCsv = useCallback(async () => {
    setExportingCsv(true);
    try {
      const limit = EXPORT_PAGE_LIMIT;
      const firstRes = await getUsersPaginated(
        buildSociosQueryParams(1, limit),
      );
      if (firstRes.status !== 200) {
        throw new Error("Respuesta no válida al exportar.");
      }
      const pagination = firstRes.data.pagination;
      const chunk0 = firstRes.data.data ?? firstRes.data;
      let allRaw = Array.isArray(chunk0) ? [...chunk0] : [];
      const totalPages =
        pagination && typeof pagination.pages === "number"
          ? pagination.pages
          : 1;

      for (let p = 2; p <= totalPages; p++) {
        const res = await getUsersPaginated(buildSociosQueryParams(p, limit));
        if (res.status === 200) {
          const chunk = res.data.data ?? res.data;
          if (Array.isArray(chunk)) allRaw = allRaw.concat(chunk);
        }
      }

      const rows = getData(allRaw, userTypes);
      const aoa = sociosRowsToXlsxAoA(rows);
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Socios");
      XLSX.writeFile(
        wb,
        `socios_${new Date().toISOString().slice(0, 10)}.xlsx`,
        {
          compression: true,
        },
      );

      alertSuccess({
        title: "Exportación lista",
        customMessage: `Se descargaron ${rows.length} fila(s).`,
      });
    } catch (error) {
      alertError({
        error,
        customMessage: "No se pudo generar el CSV de socios.",
      });
    } finally {
      setExportingCsv(false);
    }
  }, [buildSociosQueryParams, userTypes]);

  useEffect(() => {
    setLoading(true);
    const params = buildSociosQueryParams(currentPage, pageSize);

    getUsersPaginated(params)
      .then((res) => {
        if (res.status === 200) {
          const responseData = res.data.data || res.data;
          const pagination = res.data.pagination;
          setData(Array.isArray(responseData) ? responseData : []);
          setUsers(Array.isArray(responseData) ? responseData : []);
          if (pagination) {
            setTotalPages(pagination.pages || 1);
            setTotalSocios(pagination.total || 0);
          } else {
            setTotalPages(1);
            setTotalSocios(responseData?.length || 0);
          }
          setRefresh(false);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not get socios.",
        });
      })
      .finally(() => setLoading(false));
  }, [refresh, currentPage, pageSize, buildSociosQueryParams]);

  const handleSearch = () => {
    setAppliedFilterOptions({ ...filterOptions });
    setAppliedSearchText(searchText);
    setCurrentPage(1);
    localStorage.setItem("sociosPageFilters", JSON.stringify(filterOptions));
    localStorage.setItem("sociosPage_currentPage", "1");
  };

  const handleClearFilters = () => {
    setFilterOptions(initialFilters);
    setAppliedFilterOptions(initialFilters);
    setSearchText("");
    setAppliedSearchText("");
    setCurrentPage(1);
    localStorage.removeItem("sociosPageFilters");
    localStorage.removeItem("sociosPage_searchText");
    localStorage.setItem("sociosPage_currentPage", "1");
    setRefresh(true);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    localStorage.setItem("sociosPage_currentPage", newPage.toString());
  };

  const handleSortChange = (sortField, order) => {
    // Evitar reset de página cuando la tabla re-dispara el mismo sort al actualizar datos
    // (react-bootstrap-table2 puede llamar onTableChange("sort") al re-renderizar con nuevos data)
    const nextSortBy = sortField || "createdAt";
    const nextSortOrder = order || "desc";
    if (nextSortBy === sortBy && nextSortOrder === sortOrder) return;

    setSortBy(nextSortBy);
    setSortOrder(nextSortOrder);
    setCurrentPage(1);
    localStorage.setItem("sociosPage_sortBy", nextSortBy);
    localStorage.setItem("sociosPage_sortOrder", nextSortOrder);
    localStorage.setItem("sociosPage_currentPage", "1");
  };

  const handlePageSizeChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (!PAGE_SIZE_OPTIONS.includes(value)) return;
    setPageSize(value);
    setCurrentPage(1);
    localStorage.setItem("sociosPage_pageSize", value.toString());
    localStorage.setItem("sociosPage_currentPage", "1");
  };

  const renderFiltersContent = () => {
    return (
      <div style={{ padding: "5px 0 0 0" }}>
        {/* Primera fila: Filtros en grid organizado - alineados por abajo */}
        <div className="row align-items-end">
          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="search"
              label="Buscar"
              placeholder="Buscar en todos los campos..."
              value={searchText}
              onChange={(e) => {
                // Llamar directamente al handler para actualizar el ToolkitProvider
                handleTableSearchChange(e.target.value);
              }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="nAso"
              label="Número de Socio"
              type="number"
              value={filterOptions.nAso || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  nAso: e.target.value,
                })
              }
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#333",
              }}
            >
              Tipo de Usuario
            </label>
            <Select
              isMulti
              value={userTypes.filter((t) =>
                (filterOptions.tipoUsuario || []).includes(String(t._id)),
              )}
              onChange={(selected) =>
                setFilterOptions({
                  ...filterOptions,
                  tipoUsuario: selected
                    ? selected.map((s) => String(s._id))
                    : [],
                })
              }
              options={userTypes}
              getOptionLabel={(option) => option.titulo}
              getOptionValue={(option) => option._id}
              placeholder="Todos los tipos"
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "40px", // Misma altura que TextField con margin="dense"
                  borderColor: "#ced4da",
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#333",
              }}
            >
              Provincia
            </label>
            <Select
              value={
                filterOptions.provincia
                  ? provincias.find(
                      (p) => p.fullName === filterOptions.provincia,
                    )
                  : null
              }
              onChange={(selected) =>
                setFilterOptions({
                  ...filterOptions,
                  provincia: selected ? selected.fullName : null,
                })
              }
              options={provincias}
              getOptionLabel={(option) => option.fullName}
              getOptionValue={(option) => option.fullName}
              placeholder="Todas las provincias"
              isClearable
              styles={{
                control: (provided) => ({
                  ...provided,
                  minHeight: "40px", // Misma altura que TextField con margin="dense"
                  borderColor: "#ced4da",
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaAltaDesde"
              label="Fecha Alta Desde"
              type="date"
              value={filterOptions.fechaAltaDesde || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaAltaDesde: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>

          <div className="col-md-3 col-sm-6 mb-3">
            <TextField
              id="fechaAltaHasta"
              label="Fecha Alta Hasta"
              type="date"
              value={filterOptions.fechaAltaHasta || ""}
              onChange={(e) =>
                setFilterOptions({
                  ...filterOptions,
                  fechaAltaHasta: e.target.value,
                })
              }
              InputLabelProps={{ shrink: true }}
              margin="dense"
              variant="outlined"
              fullWidth
              style={{ marginTop: 0, marginBottom: 0 }}
            />
          </div>
        </div>
        {/* Switches y botones de acción en la misma línea */}
        <div className="row">
          <div className="col-12">
            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{ marginTop: "10px", marginBottom: "10px", gap: "15px" }}
            >
              {/* Switches a la izquierda */}
              <div
                className="d-flex align-items-center flex-wrap"
                style={{ gap: "30px" }}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={filterOptions.active}
                      onChange={() =>
                        setFilterOptions({
                          ...filterOptions,
                          active: !filterOptions.active,
                        })
                      }
                      name="checkActive"
                      style={{ color: "#f3691a" }}
                    />
                  }
                  label={
                    filterOptions.active
                      ? "Solo activos"
                      : "Todos (activos/inactivos)"
                  }
                  style={{ margin: 0 }}
                />
              </div>
              {/* Botones a la derecha */}
              <div className="d-flex">
                <Button
                  variant="contained"
                  onClick={handleSearch}
                  startIcon={<SearchIcon />}
                  style={{
                    minWidth: "120px",
                    backgroundColor: "#f3691a",
                    color: "#fff",
                    marginRight: "10px",
                  }}
                >
                  Buscar
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleClearFilters}
                  startIcon={<FilterOffIcon />}
                  style={{
                    minWidth: "120px",
                    borderColor: "#f3691a",
                    color: "#f3691a",
                  }}
                >
                  Limpiar
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>
        <CardHeader title="Usuarios list">
          <CardHeaderToolbar>
            <Button
              variant="outlined"
              onClick={handleExportCsv}
              disabled={exportingCsv || loading}
              startIcon={<GetAppIcon />}
              style={{
                borderColor: "#f3691a",
                color: "#f3691a",
                marginRight: "10px",
              }}
            >
              {exportingCsv ? "Generando XLSX…" : "Descargar XLSX"}
            </Button>
            <Tooltip
              title={
                user?.role !== "admin"
                  ? "Solo los administradores pueden dar de alta nuevos socios."
                  : ""
              }
            >
              <span>
                <Button
                  variant="contained"
                  onClick={() => {
                    localStorage.setItem("editUserFromSocios", "true");
                    history.push("/edit-user", { fromSocios: true });
                  }}
                  startIcon={<AddIcon />}
                  style={{
                    backgroundColor: "#f3691a",
                    color: "#fff",
                  }}
                  disabled={user?.role !== "admin"}
                >
                  Añadir nuevo
                </Button>
              </span>
            </Tooltip>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filtros siempre visibles con mejor diseño */}
          <Card style={{ marginBottom: "15px", backgroundColor: "#f8f9fa" }}>
            <CardBody style={{ padding: "15px 20px" }}>
              {renderFiltersContent()}
            </CardBody>
          </Card>

          {loading && (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <Typography>Cargando socios...</Typography>
            </div>
          )}
          {!loading && (
            <>
              <Table
                data={getData(data, userTypes)}
                columns={columns}
                pageKey="sociosPage"
                searchText={searchText}
                onSearchChange={handleTableSearchChange}
                noPagination
                remoteSort
                sort={{ dataField: sortBy, order: sortOrder }}
                onSortChange={handleSortChange}
              />
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "12px",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ minWidth: 140 }}
                >
                  <InputLabel>Filas por página</InputLabel>
                  <MuiSelect
                    value={pageSize}
                    onChange={handlePageSizeChange}
                    label="Filas por página"
                  >
                    {PAGE_SIZE_OPTIONS.map((size) => (
                      <MenuItem key={size} value={size}>
                        {size}
                      </MenuItem>
                    ))}
                  </MuiSelect>
                </FormControl>
                <Button
                  type="button"
                  variant="outlined"
                  onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  style={{ borderColor: "#f3691a", color: "#f3691a" }}
                >
                  Anterior
                </Button>
                <Typography style={{ minWidth: "180px", textAlign: "center" }}>
                  Página {currentPage} de {totalPages} ({totalSocios} socios)
                </Typography>
                <Button
                  type="button"
                  variant="outlined"
                  onClick={() =>
                    handlePageChange(Math.min(totalPages, currentPage + 1))
                  }
                  disabled={currentPage === totalPages}
                  style={{ borderColor: "#f3691a", color: "#f3691a" }}
                >
                  Siguiente
                </Button>
              </div>
            </>
          )}

          <ConfirmDialog
            title={`Are you sure you want to ${
              userId?.active ? "disable" : "enable"
            } this user?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              if (!userId || !userId.id) {
                alertError({
                  error: new Error("User ID not found"),
                  customMessage: "Could not find user ID. Please try again.",
                });
                setOpenConfirmDialog(null);
                return;
              }
              changeStatusUser(userId.id, !userId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${userId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `User ${
                        userId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      userId?.active ? "disable" : "enable"
                    } user.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this user?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteUser(userId)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "User removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove user.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
